import { TESTIMONIALS } from "../data/content";
import { Reveal } from "./Reveal";
import { Quote } from "lucide-react";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-[#0A192F]/40" />
            <span className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60">
              Said about Sean
            </span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[#0A192F] max-w-3xl">
            From the operators
            <br />
            and ministers
            <br />
            he works alongside.
          </h2>
        </Reveal>

        <div className="mt-16 lg:mt-20 grid lg:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <Reveal
              key={t.name}
              delay={i * 130}
              className={`relative bg-[#F8FAFC] p-8 lg:p-10 border border-black/5 hover:-translate-y-1 hover:shadow-xl transition-all duration-500 ${
                i === 1 ? "lg:translate-y-8" : ""
              }`}
              data-testid={`testimonial-${i}`}
            >
              <Quote className="text-[#0A192F]/15" size={36} />
              <p className="mt-6 font-serif text-xl lg:text-[22px] leading-snug text-[#0A192F]">
                "{t.quote}"
              </p>
              <div className="mt-8 pt-6 border-t border-[#0A192F]/10">
                <div className="text-[#0A192F] font-medium">{t.name}</div>
                <div className="text-sm text-[#475569] mt-1">{t.title}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
